import en from "./en.json";
import it from "./it.json";

const nft_product = { en, it };

export default nft_product;
